import React, { FC } from 'react'

import { IconPrintProps } from './IconPrint.types'
import * as Styled from './styles/IconPrint.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPrint: FC<IconPrintProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPrintProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconPrintProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M108 104H52a4 4 0 0 0 0 8h56a4 4 0 0 0 0-8zm0 24H52a4 4 0 0 0 0 8h56a4 4 0 0 0 0-8z' />
        <path d='M144 32h-16V17.33a18 18 0 0 0-18-18H50a18 18 0 0 0-18 18V32H16A16 16 0 0 0 0 48v56a16 16 0 0 0 16 16h16v36a4 4 0 0 0 4 4h74a4 4 0 0 0 2.83-1.17l14-14A4 4 0 0 0 128 142v-22h16a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM40 17.33a10 10 0 0 1 10-10h60a10 10 0 0 1 10 10V32H40zm80 123L108.34 152H40V88h80zM152 104a8 8 0 0 1-8 8h-16V84a4 4 0 0 0-4-4H36a4 4 0 0 0-4 4v28H16a8 8 0 0 1-8-8V48a8 8 0 0 1 8-8h128a8 8 0 0 1 8 8z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconPrint
